module.exports = __webpack_public_path__ + "img/Lego_Adults_sk.186b2aa8.png";